/** API 地址统一入口：生产和开发均使用 /api，生产由同域 Nginx 转发。 */
export function getApiBaseUrl(): string {
  if (process.env.NODE_ENV === 'development') return '';
  return (process.env.REACT_APP_API_BASE_URL || '').replace(/\/+$/, '');
}

/** 保留后端 /api 路径；外部链接和已带前缀的地址不重复处理。 */
export function getApiUrl(path: string): string {
  if (/^(?:[a-z][a-z\d+.-]*:|\/\/)/i.test(path)) return path;
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  if (!/^\/api(?:\/|\?|$)/.test(normalizedPath)) return normalizedPath;
  return `${getApiBaseUrl()}${normalizedPath}`;
}
